import React from "react";
import { Button, Typography } from "antd";
import PlanCard from "./planCard";
import { planDetails } from "../../../utils/constants";
import ReactHtmlParser from "react-html-parser";

const { Paragraph } = Typography;
const ContactSalesCard = props => {
    const { highlighted, otherProps } = props;
    const { header, subHeader, body, descriptions } = planDetails["Custom Plan"];
    return (
        <PlanCard
            title={header || "High Volume"}
            subTitle={subHeader}
            descriptions={descriptions}
            custom
            {...otherProps}
        >
            <Paragraph style={{ marginTop: "1rem" }}>{ReactHtmlParser(body)}</Paragraph>
            <Button
                block
                size="large"
                type={highlighted ? "primary" : "default"}
                href={"https://info.mailchannels.com/contact-sales"}
                rel="noopener noreferrer"
                target="_blank"
            >
                Contact Sales
            </Button>
        </PlanCard>
    );
};

export default ContactSalesCard;
